import type { ReactNode } from 'react';
import styles from './Quote.module.css';

interface QuoteProps {
  children: ReactNode;
  attribution?: ReactNode;
  citation?: number;
}

export default function Quote({ children, attribution, citation }: QuoteProps) {
  return (
    <>
      <blockquote className={styles.quote}>{children}</blockquote>
      {attribution && (
        <cite className={styles.cite}>
          {attribution}
          {citation !== undefined && <sup className={styles.citation}>{citation}</sup>}
        </cite>
      )}
    </>
  );
}
